/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Satellite1 = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    viewBox="0 0 132 132"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "132px",
      width: "132px",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx={66} cy={66} r={66} fill="currentColor" />
      <path
        fill="#CAD0D8"
        d="M51 23c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM40 99c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm62-46c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
      />
      <circle cx={22.5} cy={35.5} r={1.5} fill="#CAD0D8" />
      <circle cx={24.5} cy={71.5} r={1.5} fill="#CAD0D8" />
      <circle cx={22.5} cy={94.5} r={1.5} fill="#CAD0D8" />
      <circle cx={82.5} cy={98.5} r={1.5} fill="#CAD0D8" />
      <circle cx={107.5} cy={98.5} r={1.5} fill="#CAD0D8" />
      <circle cx={91.5} cy={114.5} r={1.5} fill="#CAD0D8" />
      <circle cx={103.5} cy={30.5} r={1.5} fill="#CAD0D8" />
      <circle cx={64.5} cy={10.5} r={1.5} fill="#CAD0D8" />
      <circle cx={37.5} cy={47.5} r={1.5} fill="#CAD0D8" />
      <g transform="translate(9 54)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(79 22)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(63 112)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(116 69)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M64.532 72.46a7.5 7.5 0 1 1 7.5-7.5l-7.5 7.5z" />
        <path
          fill="#F18686"
          d="M71.956 48.638l4.244-4.244a2.998 2.998 0 0 1 4.242 0l4.242 4.242a2.998 2.998 0 0 1 0 4.242l-4.242 4.242a2.998 2.998 0 0 1-4.242 0l-4.244-4.24a3.002 3.002 0 0 1 0-4.242z"
        />
        <path
          fill="#74B0F4"
          d="M44.378 76.628l4.242-4.242a2.998 2.998 0 0 1 4.242 0l4.242 4.242a2.998 2.998 0 0 1 0 4.242l-4.242 4.242a2.998 2.998 0 0 1-4.242 0l-4.242-4.242a2.998 2.998 0 0 1 0-4.242z"
        />
        <path d="M56.046 56.474l3.182 3.182m16.71 9.87a10.53 10.53 0 0 1-6.376 6.388M82.3 68.826a16.512 16.512 0 0 1-13.458 13.456M88.5 67.328C87.828 78.858 78.538 88.006 67 88.5" />
      </g>
    </g>
  </svg>
));
